export default __webpack_public_path__ + "static/media/JE.23739555.svg";